import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/organization-team-manage/stage/:id',
    component: () => import('./views/StageTeamMange/index.vue'),
    meta: {
      title: 'Управление организаторами',
      accessList: [ROLES.organization],
      layout: 'ui-design',
      back: true,
    },
  },
  {
    path: '/organization/events/manage',
    name: 'organization-events-manage',
    component: () => import('@/modules/UIDesign/Events/views/events-management/organization-events-review.vue'),
    meta: {
      title: 'Управление организаторами',
      accessList: [ROLES.organization],
      layout: 'ui-design',
      back: true,
    },
  },
];

export default routes;
